import ApiClient from '../backend/ApiClient'
import { buildQueryKey } from '../components/hooks/useQuery'
import { ISystemConfig } from '../definitions/MiscSchema'

export type Filter = 'Claim status' | 'Providers' | 'Patients' | 'Members' | 'Quality Measures' | 'Funds' | 'Contracts' | 'Type' | 'Line Of Business' |
    'Provider Groups' | 'Fund Stategies' | 'ICD 10 Codes' | 'Status' | 'Task Statuses' | 'Arrangement Types' | 'Fee Cost Bases' | 'Contingency Cost Bases' |
    'Shared Cost Bases' | 'Business Segments'

class FilterManagerClass {
    getFilter = (name: Filter, contractId?: number): { key: string, backendCall: () => Promise<ISystemConfig[]> } => {
        switch (name) {
            case 'Claim status': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getClaimStatusFilter(contractId)
            }
            case 'Members': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getMembersFilter(contractId)
            }
            case 'Patients': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getPatientsFilter(contractId)
            }
            case 'Providers': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getProvidersFilter(contractId)
            }
            case 'Quality Measures': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getQualityMeasuresFilter(contractId)
            }
            case 'Funds': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getFundsFilter(contractId)
            }
            case 'ICD 10 Codes': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase(), contractId),
                backendCall: async () => await ApiClient.Filters.getICD10CodeFilter()
            }
            case 'Contracts': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getContractsFilter()
            }
            case 'Type': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getContractType()
            }
            case 'Line Of Business': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getLineOfBusiness()
            }
            case 'Provider Groups': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => (await ApiClient.getAllCounterparties()).map(x => ({ uuid: x.id.toString(), id: x.id, name: x.name }))
            }
            case 'Fund Stategies': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getFundingStrategies()
            }
            case 'Status': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getContractStatuses()
            }
            case 'Task Statuses': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getTaskStatuses()
            }
            case 'Arrangement Types': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getArrangementTypes()
            }
            case 'Business Segments': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getBusinessSegments()
            }
            case 'Shared Cost Bases': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getSharedCostBases()
            }
            case 'Contingency Cost Bases': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getContingencyCostBases()
            }
            case 'Fee Cost Bases': return {
                key: buildQueryKey('filter-', name.toLocaleLowerCase()),
                backendCall: async () => await ApiClient.Filters.getFeeCostBases()
            }
        }
    }
}

const FilterManager = new FilterManagerClass()
export default FilterManager
